const name = 'time_interval';
export default {
  name,
  resolvers: {},
};
